import { config } from '@/lib/env-helpers';
import { Device } from '@twilio/voice-sdk';

export const deviceOptions: Device.Options = {
  tokenRefreshMs: config.TWILIO_REFRESH_MS ? Number(config.TWILIO_REFRESH_MS) : 60000,
  allowIncomingWhileBusy: false,
  logLevel: 'ERROR',
  // show alert when leaving page during call
  closeProtection: true,
};
